import { render } from "./FristWechselButton.vue?vue&type=template&id=012521ad"
import script from "./FristWechselButton.vue?vue&type=script&lang=js"
export * from "./FristWechselButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__